import PanelInlineContent from "../../lib/panel/panel-inline-content";
import { ToggleGroup, ToggleGroupItem } from "@babackapp/ui/components/toggle-group";
import { EyeOff } from "lucide-react";
import { useBlockPanelPropsContext } from "../../lib/panel/panel-container";
import { SeparatorBlock, SeparatorBlockProps } from "./types";
import { useTranslation } from "react-i18next";

export default function EmailPanelInvisible() {
  const { t } = useTranslation("editor-blocks-library");
  const blockProps = useBlockPanelPropsContext<SeparatorBlockProps>();
  const value = blockProps.block.properties?.invisible ? "on" : "off";

  const handleUpdate = (enabled: boolean) => {
    blockProps.formAPI.updateField<SeparatorBlock>(blockProps.formAPI.blockPath, {
      ...blockProps.block,
      properties: {
        ...blockProps.block.properties,
        invisible: enabled,
      },
    });
  };

  return (
    <PanelInlineContent
      title={t(
        "editorBlocksLibrary.blocks.separator.panel.invisible.title",
        "Invisible",
      )}
    >
      <ToggleGroup
        variant="default"
        type="single"
        className="bg-background border shadow"
        value={value}
        onValueChange={(value) => {
          if (value === "on" || value === "off") {
            handleUpdate(value === "on");
          }
        }}
      >
        <ToggleGroupItem value="on" aria-label="Invisible">
          <EyeOff className="h-4 w-4" />
        </ToggleGroupItem>
        <ToggleGroupItem value="off" aria-label="Visible">
          <span className="text-xs font-medium">
            {t(
              "editorBlocksLibrary.blocks.separator.panel.invisible.off",
              "Off",
            )}
          </span>
        </ToggleGroupItem>
      </ToggleGroup>
    </PanelInlineContent>
  );
}
